import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../../../auth/auth.service';

@Component({
  selector: 'app-request-queueing-test',
  templateUrl: './request-queueing-test.component.html',
  styleUrls: ['./request-queueing-test.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RequestQueueingTestComponent implements OnInit {
  queueRequests = false;

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.authService.isRefreshing$
      .subscribe(x => {
        if(this.queueRequests !== x) {
          this.queueRequests = x;
        }
    });
  }

  onChange() {
    if (this.queueRequests) {
      this.authService.enableQueueTest();
    } else {
      this.authService.disableQueueTest();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/header/request-queueing-test/request-queueing-test.component.ts